import React from 'react';
import './Contact.css';
import ScrollReveal from '../components/ScrollReveal';

// Icon Components
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);

export default function Contact() {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <ScrollReveal>
        <section className="contact-hero">
          <div className="contact-hero-content">
            <h1>අපව අමතන්න</h1>
            <p>අපගේ සේවාවන් පිළිබඳ ඕනෑම ගැටළුවක් සඳහා අප හා සම්බන්ධ වන්න</p>
            <div className="contact-hero-line"></div>
          </div>
        </section>
      </ScrollReveal>

      <div className="contact-container">
        <div className="contact-grid">
          {/* Contact Info Cards */}
          <ScrollReveal>
            <div className="contact-info-panel">
              <div className="info-card">
                <div className="info-icon"><PhoneIcon /></div>
                <div className="info-content">
                  <h3>Phone</h3>
                  <p>071 - 0 999 499</p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon"><EmailIcon /></div>
                <div className="info-content">
                  <h3>Email</h3>
                  <p>koreansirlk@gmail.com</p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon"><LocationIcon /></div>
                <div className="info-content">
                  <h3>Address</h3>
                  <p className="korean-text">경북 칠곡군 왜관읍 2산업단지3길 97 센템빌 102동</p>
                  <p className="english-text">Centembil 102-dong, 97 2-san-eop-dan-ji-3-gil, Waegwan-eup, Chilgok-gun, Gyeongbuk</p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* Contact Form */}
          <ScrollReveal>
            <div className="contact-form-panel">
              <form className="contact-form">
                <div className="form-group">
                  <label>Full Name</label>
                  <input type="text" placeholder="Enter your full name" />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" placeholder="Enter your email address" />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" placeholder="Message subject" />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea placeholder="Write your message here" rows="5"></textarea>
                </div>
                <button type="submit" className="contact-submit-btn">Send Message</button>
              </form>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}
